module.exports = __webpack_public_path__ + "img/target.031beded.svg";